import React from "react";
import { MessageCircle, Phone, Send } from "lucide-react";
import { telLink, waLink } from "@/lib/site";

export const StickyCTA = () => (
  <div
    data-testid="sticky-cta"
    className="fixed z-40 bottom-4 inset-x-4 md:inset-x-auto md:right-6 md:bottom-6"
  >
    <div className="mx-auto md:mx-0 max-w-md md:max-w-none flex items-center gap-2 rounded-full bg-white/95 backdrop-blur-xl border border-slate-200 shadow-[0_20px_60px_rgb(10,25,47,0.15)] p-1.5">
      <a href={waLink()} target="_blank" rel="noopener noreferrer" data-testid="sticky-wa-btn"
         className="flex-1 md:flex-none inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] text-white px-4 md:px-5 py-2.5 text-sm font-semibold hover:brightness-95 transition-all">
        <MessageCircle className="h-4 w-4" /> <span className="hidden sm:inline">WhatsApp</span>
      </a>
      <a href={telLink} data-testid="sticky-call-btn"
         className="flex-1 md:flex-none inline-flex items-center justify-center gap-2 rounded-full bg-white text-[#0A192F] border border-slate-200 px-4 md:px-5 py-2.5 text-sm font-semibold hover:bg-slate-50 transition-all">
        <Phone className="h-4 w-4" /> <span className="hidden sm:inline">Call</span>
      </a>
      <a href="#contact" data-testid="sticky-quote-btn"
         className="flex-1 md:flex-none inline-flex items-center justify-center gap-2 rounded-full bg-[#0A192F] text-white px-4 md:px-5 py-2.5 text-sm font-semibold hover:bg-[#0F172A] transition-all">
        <Send className="h-4 w-4" /> <span className="hidden sm:inline">Get Quote</span>
      </a>
    </div>
  </div>
);
